
const useIsAppRoute = () => {

    const uri = window.location.pathname
    
    const patt = /^\/app\/.*$/
    const isAppPath = patt.test(uri)

    return { isAppPath }
}

export { useIsAppRoute }
